(function() {
    function postResize() {
        const height = document.body.scrollHeight;
        window.parent.postMessage({
            type: "resize-iframe",
            id: "aloharmony-checkout-iframe",
            height
        }, "*");
    }
    // Trigger resize on load
    window.addEventListener("load", ()=>{
        postResize();
        // Safety delay to ensure fonts or async content finishes
        setTimeout(postResize, 0); // next tick
        setTimeout(postResize, 300); // fallback for async styles
        setTimeout(postResize, 1000); // absolute fallback
    });
    // // Watch for DOM changes
    const observer = new MutationObserver(()=>{
        postResize();
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
    });
})();

//# sourceMappingURL=checkout-stripe-iframe.4d843581.js.map
